import Directory from '../../components/directory/directory.component';

export const Home = () => <Directory />;

